import UserSVG from '../../../assets/imgs/icon/user.svg';
import { useNavigate } from 'react-router-dom';

export const LoginButton: React.FC = () => {
	const navigate = useNavigate();
	const login = () => {
		navigate('/login', { replace: true });
	};

	return (
		<div className="w-100 h-100 d-flex align-items-center px-3 text-primary rounded-0 bg-primary border-0 header-login-button">
			<div
				className="d-flex align-items-center"
				style={{
					backgroundColor: '#fff',
					borderRadius: '50%',
					height: '32px',
					width: '32px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginRight: '8px'
				}}
			>
				<img
					style={{
						width: '18px',
						height: '18px'
					}}
					src={UserSVG}
				/>
			</div>

			<div
				onClick={login}
				className="h-100 d-flex align-items-center text-white text-lightened-primary-hover bg-lightened-primary-hover cursor-pointer"
			>
				Log into my account
			</div>
			<span style={{ margin: '0 4px', color: '#fff' }}> || </span>
			<a
				href={`${import.meta.env.VITE_APP_OAUTH_API_URL}/register`}
				className="h-100 d-flex align-items-center text-white text-lightened-primary-hover bg-lightened-primary-hover cursor-pointer"
				style={{ textDecoration: 'none' }}
			>
				Sign up
			</a>
		</div>
	);
};
